import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../contexts/AuthContext.js";
import { parseSportsHandoffUrl } from "./sportsHandoffUrl.js";

export default function SportsHandoff() {
  const { token } = useContext(AuthContext);
  const [error, setError] = useState("");
  const [canRetry, setCanRetry] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let cancelled = false;
    const handoff = parseSportsHandoffUrl(window.location.pathname + window.location.search);
    setError("");
    setCanRetry(false);

    async function completeHandoff() {
      try {
        if (!handoff) {
          setError("This sports sign-in link is invalid. Please use the Sports menu again.");
          return;
        }
        const loginUrl = `/login?${new URLSearchParams({ returnTo: handoff.path })}`;
        if (!token) {
          window.location.replace(loginUrl);
          return;
        }
        const response = await fetch("/api/sso/vyralsports/session", {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          credentials: "same-origin",
          body: JSON.stringify({ state: handoff.state, sport: handoff.sport }),
          cache: "no-store",
        });
        if (cancelled) return;
        if (response.status === 401 || response.status === 403) {
          window.location.replace(loginUrl);
        } else if (response.status === 204) {
          window.location.replace(`/api/sso/vyralsports?${new URLSearchParams({
            state: handoff.state, sport: handoff.sport,
          })}`);
        } else if (response.status === 400) {
          setError("This sports sign-in link is invalid. Please use the Sports menu again.");
        } else {
          setError("Automatic sports sign-in is temporarily unavailable. Please try again.");
          setCanRetry(true);
        }
      } catch (err) {
        if (!cancelled) {
          setError("Automatic sports sign-in is temporarily unavailable. Please try again.");
          setCanRetry(true);
        }
      }
    }
    completeHandoff();
    return () => { cancelled = true; };
  }, [token, attempt]);
  return <section className="section-container" style={{ padding: "2rem" }}>
    <h1>Continue to VyralSports</h1>
    {error ? <p role="alert">{error}</p> : <p>Verifying your sign-in…</p>}
    {canRetry && <button type="button" onClick={() => setAttempt(value => value + 1)}>Try again</button>}
  </section>;
}